import { SMS_AND_BANKID, BANKID, SMS } from 'constants/verificationTypes'

export const formatObjectId = (type) => {
  if (!type) {
    return null
  }
  return (
    (type === SMS_AND_BANKID && 'ad_reply_verification_prompt') ||
    (type === BANKID && 'ad_reply_bankid_verification_prompt') ||
    (type === SMS && 'ad_reply_sms_verification_prompt')
  )
}

export const formatObjectIdSuffix = (type) => {
  const prefix = 'verify_by_'
  return type === 'dismiss' ? 'dismiss' : type === 'sms' ? `${prefix}sms` : `${prefix}bankid`
}

export const formatBlockReasonTracking = (type) => {
  switch (type) {
    case '400402_offensive':
      return 'offensive'
    case '400401_failure':
      return 'fraud'
    case '400403_promotion':
      return 'promotion'
    case '400404_misc':
      return 'misc'
    default:
      break
  }
}
